import React from "react";
import { NavLink } from "react-router-dom";
import "./listItem.css";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

const ListItemComponent = ({
  data,
  setMobileOpen,
  setExpanded,
  isDrawerExpanded,
}) => {
  return (
    <div>
      <ListItem
        component={NavLink}
        className="sideBar"
        to={`/${data.slug}`}
        onClick={() => {
          setMobileOpen(false);
          setExpanded("");
        }}
        sx={{
          color: "#fff",
          justifyContent: isDrawerExpanded ? "initial" : "center",
          px: isDrawerExpanded ? 2 : 1,
        }}
      >
        <ListItemIcon
          sx={{
            color: "#fff",
            minWidth: isDrawerExpanded ? 40 : "auto",
            justifyContent: "center",
          }}
        >
          <data.icon />
        </ListItemIcon>
        {isDrawerExpanded && (
          <ListItemText
            primaryTypographyProps={{ fontSize: "14px" }}
            primary={data.text}
          />
        )}
      </ListItem>
    </div>
  );
};

export default ListItemComponent;
